/**
 * Utility functions for tracking Facebook ad parameters
 */

/**
 * Captures Facebook ad parameters from the URL and stores them in localStorage
 * This function extracts fbclid and UTM parameters that come from Facebook ads
 * @returns {Object} The captured ad parameters
 */
export const captureFacebookAdParams = () => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const fbclid = urlParams.get("fbclid");
    const utm_source = urlParams.get("utm_source");
    const utm_medium = urlParams.get("utm_medium");
    const utm_campaign = urlParams.get("utm_campaign");
    const utm_content = urlParams.get("utm_content");
    const utm_term = urlParams.get("utm_term");

    const adParams = {};

    if (fbclid) adParams.fbclid = fbclid;
    if (utm_source) adParams.utm_source = utm_source;
    if (utm_medium) adParams.utm_medium = utm_medium;
    if (utm_campaign) adParams.utm_campaign = utm_campaign;
    if (utm_content) adParams.utm_content = utm_content;
    if (utm_term) adParams.utm_term = utm_term;

    // Store in localStorage for persistence if we have any parameters
    if (Object.keys(adParams).length > 0) {
      console.log("📊 Captured Facebook ad parameters:", adParams);
      localStorage.setItem("fb_ad_params", JSON.stringify(adParams));
      return adParams;
    }
  } catch (error) {
    console.error("Error capturing Facebook ad parameters:", error);
  }

  return null;
};

/**
 * Gets the stored Facebook ad parameters from localStorage
 * @returns {Object|null} The stored ad parameters or null if none exist
 */
export const getStoredAdParams = () => {
  try {
    const storedParams = localStorage.getItem("fb_ad_params");
    if (storedParams) {
      return JSON.parse(storedParams);
    }
  } catch (error) {
    console.error("Error retrieving ad parameters from localStorage:", error);
  }
  return null;
};

/**
 * Clears the stored Facebook ad parameters from localStorage
 */
export const clearStoredAdParams = () => {
  try {
    localStorage.removeItem("fb_ad_params");
  } catch (error) {
    console.error("Error clearing ad parameters from localStorage:", error);
  }
};

export default {
  captureFacebookAdParams,
  getStoredAdParams,
  clearStoredAdParams,
};
